import React, { Component } from "react";
import { connect } from "react-redux";
import * as d3Time from "d3-time";

import { timestampCoarse, timestampMeridiem } from "../../modules/format";

import {
    setPlaying,
    selectPlaying,
    selectDuration,
    selectCurrentTimestamp,
} from "../../ducks/time";

import { IconPlay, IconPause } from "../icons";

import Styles from "./time-controls.module.scss";

const VIS_HEIGHT = 13;
const VIS_BASE_HEIGHT = 5;

class TimeControls extends Component {
    constructor(props) {
        super(props);
        this.state = {
            renderReady: false,
        };
    }

    componentDidMount() {
        this.setState({
            renderReady: true,
        });
    }

    renderVisContent() {
        if (!this.state.renderReady) return null;

        const { timeScale, currentTimestamp, video } = this.props;
        const progressWidth = timeScale(currentTimestamp) + "%";

        const isOverAnHour = video.processed.timeLength > 60 * 60;

        const bigTicks = timeScale.ticks(d3Time.timeMinute.every(isOverAnHour ? 10 : 1));
        const smallTicks = timeScale.ticks(d3Time.timeSecond.every(isOverAnHour ? 60 : 10));

        const bigTickEls = bigTicks.map((tickTime, index) => {
            const x = timeScale(tickTime);
            const height = 8;
            return (
                <line
                    key={index}
                    className={Styles.tickBig}
                    x1={x + "%"}
                    x2={x + "%"}
                    y1={VIS_HEIGHT - height - VIS_BASE_HEIGHT}
                    y2={VIS_HEIGHT - VIS_BASE_HEIGHT}
                    height={height}
                />
            );
        });

        const smallTickEls = smallTicks.map((tickTime, index) => {
            const x = timeScale(tickTime);
            const height = 5;
            return (
                <line
                    key={index}
                    className={Styles.tickSmall}
                    x1={x + "%"}
                    x2={x + "%"}
                    y1={VIS_HEIGHT - height - VIS_BASE_HEIGHT}
                    y2={VIS_HEIGHT - VIS_BASE_HEIGHT}
                    height={height}
                />
            );
        });

        return (
            <React.Fragment>
                <rect
                    className={Styles.baseLine}
                    x={0}
                    width={"100%"}
                    y={VIS_HEIGHT - VIS_BASE_HEIGHT}
                    height={VIS_BASE_HEIGHT}
                />
                <g>{smallTickEls}</g>
                <g>{bigTickEls}</g>
                <rect
                    className={Styles.progressLine}
                    x={0}
                    width={progressWidth}
                    y={0}
                    height={VIS_HEIGHT}
                />
            </React.Fragment>
        );
    }

    renderVis() {
        const { video } = this.props;

        const timeExtentLabels = video.processed.extents.time.map(
            (time, index) => {
                return (
                    <label key={index}>
                        <strong>{timestampCoarse(time)}</strong>
                        {timestampMeridiem(time)}
                    </label>
                );
            }
        );

        return (
            <div className={Styles.visContainer}>
                <div className={Styles.visTimeContainer}>
                    {timeExtentLabels}
                </div>
                <svg className={Styles.vis} ref={r => (this.svg = r)}>
                    {this.renderVisContent()}
                </svg>
            </div>
        );
    }

    render() {
        const { duration, playing, setPlaying } = this.props;
        const playPauseButton = duration ? (
            <button
                className={Styles.playPauseButton}
                onClick={() => setPlaying(!playing)}
                data-playing={playing}
            >
                {playing ? <IconPause /> : <IconPlay />}
            </button>
        ) : (
            <p className={Styles.loadingText}>Please wait...</p>
        );
        return (
            <div className={Styles.timeControls}>
                <div className={Styles.leftContainer}>
                    <img
                        className={Styles.logo}
                        src={`${process.env.PUBLIC_URL}/img/logo.svg`}
                        alt="Super Loci Logo"
                    />
                    {playPauseButton}
                </div>
                <div className={Styles.rightContainer}>{this.renderVis()}</div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        playing: selectPlaying(state),
        duration: selectDuration(state),
        currentTimestamp: selectCurrentTimestamp(state, props.video),
    };
};
const mapDispatchToProps = {
    setPlaying,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TimeControls);



// WEBPACK FOOTER //
// ./src/components/time-controls/time-controls.js